import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "type", "placeholder", "required", "name", "readonly", "maxlength"]
const _hoisted_4 = {
  key: 0,
  class: "text-[10px] text-neutral-400 mt-1"
}

import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
	modelValue: {
		default: null,
		required: true,
	},
	id: {
		type: String,
		default: null,
	},
	placeholder: {
		type: String,
		default: null,
	},
	label: {
		type: String,
		default: null,
	},
	name: {
		type: String,
		default: null,
	},
	helper: {
		type: String,
		default: null,
	},
	error: {
		type: String,
		default: null,
	},
	isRequired: {
		type: Boolean,
		default: false,
	},
	readonly: {
		type: Boolean,
		default: false,
	},
	maxlength: {
		type: Number,
	},
},
  setup(__props) {



const showPassword = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: __props.id,
      class: "block text-xs font-semibold text-neutral-600"
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["relative rounded", __props.label ? 'mt-2' : '']),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = showPassword.value))
    }, [
      _createElementVNode("input", {
        id: __props.id,
        type: showPassword.value ? 'text' : 'password',
        class: "block w-full h-12 text-sm rounded disabled:bg-gray-100 focus:outline-none focus:ring-0 focus:border-neutral-900 text-neutral-800 border-neutral-100 placeholder-neutral-400 placeholder:font-medium pr-11",
        placeholder: __props.placeholder,
        required: __props.isRequired,
        name: __props.name,
        readonly: __props.readonly,
        maxlength: __props.maxlength,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }, null, 40, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
        class: "absolute inset-y-0 right-0 flex items-center px-3 cursor-pointer"
      }, [
        (!showPassword.value)
          ? (_openBlock(), _createBlock(_unref(EyeIcon), {
              key: 0,
              class: "w-6 h-6 text-neutral-400",
              "aria-hidden": "true"
            }))
          : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
              key: 1,
              class: "w-6 h-6 text-neutral-400",
              "aria-hidden": "true"
            }))
      ])
    ], 2),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})